import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  dealershipsCardFrame: {
    padding: '12px 16px',
    margin: '6px',
    background: '#F7F7F7',
  },
  dealershipTitleText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '12px',
    lineHeight: '15px',
    color: '#000000',
  },
  dealershipSubTitleText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '15px',
    color: 'rgba(0, 0, 0, 0.4)',
  },
}));
const DealershipCard = (props) => {
  const classes = useStyles();

  return (
    <div style={{ marginRight: '16px', maxWidth: '100%', boxSizing: 'border-box' }}>
      <Grid item>
        <Grid container direction="row" className={classes.dealershipsCardFrame} justifyContent="space-between">
          <Grid item className={classes.dealershipTitleText}>
            {props.textVal}
          </Grid>
          <Grid item className={classes.dealershipSubTitleText}>
            {`${props.empCount} Users`}
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default DealershipCard;
